import { WebPageEvents } from '@griply/types';
import { CircularProgress, Skeleton } from '@mui/material';
import React from 'react';
import { Sizes } from 'shared/components/ui/button';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';

import { PremiumLayout } from '../components/premium-layout';
import { PriceDisplay } from '../components/price-display';
import { PricingCard } from '../components/pricing-card';
import * as Styled from './premium.style';

export type PremiumProps = {
  onSkip: () => void;
};

export const PremiumLoading: React.FC<PremiumProps> = ({ onSkip }) => {
  useTrackPageVisitEvent(WebPageEvents.OnboardingPremium, undefined);

  return (
    <PremiumLayout
      onSkip={onSkip}
      card={
        <PricingCard
          toggle={<Skeleton animation="wave" width="6rem" height="2rem" />}
          price={
            <PriceDisplay
              amount={
                <Skeleton animation="wave" width="8rem" height="3.6rem" />
              }
              caption={<Skeleton animation="wave" width="16rem" />}
            />
          }
          cta={
            <Styled.CtaButton
              type="button"
              size={Sizes.Large}
              disabled
              fullWidth
              alignCenter
              disabledBackgroundOnly
            >
              <CircularProgress color="primary" size={20} />
            </Styled.CtaButton>
          }
        />
      }
    />
  );
};
